<template>
  <div class="rep-dial">
    <div class="rep-container">
      <div class="label">{{ $t('reputation-management-requirement-met') }}</div>
      <div class="data">{{ dialInfo.result[0].data[0].data }}</div>
    </div>
    <div class="rep-container">
      <div class="label">{{ $t('reputation-management-type') }}</div>
      <div class="data">{{ dialInfo.type[0].data[0].data }}</div>
    </div>
    <div class="rep-container">
      <div class="label">{{ $t('reputation-management-company') }}</div>
      <div class="data">{{ dialInfo.company[0].data[0].data }}</div>
    </div>
    <Upload />
  </div>
</template>

<script>
import Upload from '@/components/Upload.vue';

export default {
  name: 'RM',
  components: {
    Upload,
  },
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.rep-dial {
  font-size: 14px;
  color: black;
  .rep-container {
    display: flex;
    margin-top: 20px;
    .label {
      margin-right: 10px;
      align-items: center;
      display: flex;
    }
    .data {
      display: inline-block;
      background: #f3f3f5;
      border: 1px solid #e4e8e7;
      border-radius: 3px;
      padding: 5px 10px 3px 10px;
      text-align: left;
      font-size: 14px;
    }
  }
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: #e0ffff;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
